import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconUsers: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}
                >
                    <path
                        d="M7.16707 4.66667C7.16707 5.86328 6.19702 6.83333 5.00041 6.83333C3.80379 6.83333 2.83374 5.86328 2.83374 4.66667C2.83374 3.47005 3.80379 2.5 5.00041 2.5C6.19702 2.5 7.16707 3.47005 7.16707 4.66667Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13.1671 4.66667C13.1671 5.86328 12.197 6.83333 11.0004 6.83333C9.80379 6.83333 8.83374 5.86328 8.83374 4.66667C8.83374 3.47005 9.80379 2.5 11.0004 2.5C12.197 2.5 13.1671 3.47005 13.1671 4.66667Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M0.747638 12.7869C0.686977 13.1688 0.995382 13.5 1.38203 13.5H8.52283C8.90948 13.5 9.21788 13.1688 9.15722 12.7869C8.24922 7.07102 1.65564 7.07102 0.747638 12.7869Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.61743 8.78695C11.8587 7.85608 14.6828 9.19005 15.2535 12.7889C15.3141 13.1707 15.0055 13.5 14.6188 13.5H11.1674"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
